import { Box, Grid, Skeleton, Stack } from "@mui/material";

/**
 * CostsSkeleton — KPI boxes + chart bars + by-workload table,
 * matching the Costs tab layout.
 */
export function CostsSkeleton(): React.ReactElement {
  const cardSx = {
    border: "1px solid",
    borderColor: "divider",
    borderRadius: "12px",
    p: 2.5,
    bgcolor: "background.paper",
  };

  return (
    <Stack spacing={2}>
      {/* KPI boxes */}
      <Grid container spacing={1.5}>
        {[1, 2, 3, 4].map((i) => (
          <Grid item xs={6} sm={3} key={i}>
            <Skeleton
              variant="rounded"
              width="100%"
              height={84}
              sx={{ borderRadius: "12px" }}
            />
          </Grid>
        ))}
      </Grid>

      {/* Cost grid */}
      <Grid container spacing={2}>
        {/* Cost by category bars */}
        <Grid item xs={12} md={7}>
          <Box sx={cardSx}>
            <Skeleton variant="text" width={130} height={16} sx={{ mb: 2 }} />
            <Stack spacing={1.5}>
              {[1, 2, 3, 4, 5].map((i) => (
                <Stack
                  key={i}
                  direction="row"
                  spacing={1.5}
                  alignItems="center"
                >
                  <Skeleton variant="text" width={130} height={14} />
                  <Skeleton
                    variant="rounded"
                    width="100%"
                    height={10}
                    sx={{ borderRadius: "5px", flex: 1 }}
                  />
                  <Skeleton variant="text" width={60} height={14} />
                </Stack>
              ))}
            </Stack>
          </Box>
        </Grid>

        {/* By workload */}
        <Grid item xs={12} md={5}>
          <Box sx={cardSx}>
            <Skeleton variant="text" width={100} height={16} sx={{ mb: 2 }} />
            <Stack spacing={1.5}>
              {[1, 2, 3, 4].map((i) => (
                <Skeleton key={i} variant="text" width="100%" height={20} />
              ))}
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  );
}

export default CostsSkeleton;
